"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _LocalizationProvider = require("@mui/x-date-pickers/LocalizationProvider");
var _AdapterDateFns = require("@mui/x-date-pickers/AdapterDateFns");
var _DesktopDatePicker = require("@mui/x-date-pickers/DesktopDatePicker");
var _system = require("@mui/system");
var _material = require("@mui/material");
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
var _fr = _interopRequireDefault(require("date-fns/locale/fr"));
var _enCA = _interopRequireDefault(require("date-fns/locale/en-CA"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledDesktopDatePicker = (0, _system.styled)(_DesktopDatePicker.DesktopDatePicker)({
  width: "100%"
});
var StyledTextField = (0, _system.styled)(_material.TextField)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiOutlinedInput-root': {
      "&:hover fieldset": {
        // sets the border color of the outlined variant
        borderColor: theme.palette.custom.textFieldHover
      }
    }
  };
});
var MonthPicker = /*#__PURE__*/function (_Component) {
  function MonthPicker() {
    var _this;
    (0, _classCallCheck2["default"])(this, MonthPicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, MonthPicker, [].concat(args)), _this.state = {
      selectedDate: _this.props.value
    }, _this._handleDateChange = function (date) {
      var firstOfSelectedMonth = new Date(date.getFullYear(), date.getMonth(), 1);
      _this.setState({
        selectedDate: firstOfSelectedMonth
      });
      _this.props.onChange(firstOfSelectedMonth);
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(MonthPicker, _Component);
  return (0, _createClass2["default"])(MonthPicker, [{
    key: "render",
    value: function render() {
      var customStyle = this.props.customStyle;
      return /*#__PURE__*/_react["default"].createElement(_LocalizationProvider.LocalizationProvider, {
        dateAdapter: _AdapterDateFns.AdapterDateFns,
        adapterLocale: _i18n["default"].locale === "fr" ? _fr["default"] : _enCA["default"]
      }, /*#__PURE__*/_react["default"].createElement(StyledDesktopDatePicker, {
        sx: _objectSpread({}, customStyle),
        variant: "inline",
        views: ['year', 'month'],
        openTo: "year",
        label: _i18n["default"].t(_tokens["default"].labels.dates.monthAndYear),
        inputVariant: "outlined",
        fullWidth: true,
        value: this.state.selectedDate,
        onChange: this._handleDateChange,
        renderInput: function renderInput(params) {
          return /*#__PURE__*/_react["default"].createElement(StyledTextField, (0, _extends2["default"])({}, params, {
            inputProps: _objectSpread(_objectSpread({}, params.inputProps), {}, {
              readOnly: true
            })
          }));
        }
      }));
    }
  }]);
}(_react.Component);
var _default = exports["default"] = MonthPicker;